<template>
  <div class="order_list_container">
    <my-header/>

    <div class="detail_menu bg_white">
      <ul>
        <li :class="{active: tab=='index'}" @click="changeTab('index')">全部</li>
        <li :class="{active: tab=='nopaid'}" @click="changeTab('nopaid')">待付款</li>
        <li :class="{active: tab=='paid'}" @click="changeTab('paid')">未出行</li>
        <li :class="{active: tab=='noevaluated'}" @click="changeTab('noevaluated')">待评价</li>
        <li :class="{active: tab=='done'}" @click="changeTab('done')">已完成</li>
      </ul>
    </div>
    <router-view/>

  </div>
</template>

<script>
import myHeader from '@/components/myHeader.vue'

export default {
  name: 'order-list',
  props: [],
  data () {
    return {
      tab: 'index'
    }
  },
  components: {
    myHeader
  },
  created () {
    this.tab = this.$route.meta.tab || 'index'
  },
  methods: {
    changeTab (tab) {
      this.tab = tab
      this.$router.push(tab)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "@/assets/css/mixin.scss";
  .detail_menu {
    width: 100%;
    padding-top: rem(10);
    border-bottom: 1px solid #eeeeee;
    ul:after {
      content: '';
      clear: both;
      display: block;
    }
    li {
      font-size: rem(24);
      color: #333;
      text-align: center;
      float: left;
      height: rem(55);
      line-height: rem(55);
      width: 20%;
      &.active {
        color: #ff9500;
        border-bottom: rem(4) solid #ff9500;
      }
    }
  }
</style>
